module.exports = __webpack_public_path__ + "img/20.0c6a348e.jpg";